<template>
    <b-modal v-model="show" size="lg" title="БИНО КОНСТРУКТИВ ЭЛЕМЕНТИ">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Кадастр иншоат тури</label>
                                        <v-select label="name"
                                                  v-model="data.section"
                                                  :options="cadastreSections"
                                                  :filterable="false"
                                                  @search="onCadastreSectionSearch"
                                                  @search:focus="onCadastreSectionFocus"
                                                  @change="onChangeCadastreSection"
                                        >
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                    </div>
                                    <div class="form-group">
                                        <label>Бино тури <span class="red">*</span></label>
                                        <v-select
                                                label="name"
                                                v-model="data.cadastreBuilding"
                                                :options="cadastreBuildings"
                                                :filterable="false"
                                                @search="onCadastreBuildingSearch"
                                                @search:focus="onCadastreBuildingFocus"
                                                @change="onChangeCadastreBuilding"
                                                :class="{invalid: $v.data.cadastreBuilding.$error}"
                                        >
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                    </div>
                                    <div class="form-group">
                                        <label>Фойдаланиш мақсади <span class="red">*</span></label>
                                        <v-select v-model="data.buildingType" label="name"
                                                  :options="buildingTypes"
                                                  :filterable="false"
                                                  @search:focus="onBuildingFocus"
                                                  :class="{invalid: $v.data.buildingType.code.$error}"
                                        >
                                            <template slot="option" slot-scope="option" v-if="option && option.name">
                                                <div v-html="option.name"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                    </div>
                                    <div class="form-group">
                                        <label>Зилзила бардошлилик </label>
                                        <select
                                                class="form-control"
                                                v-model="data.earthquakePoint"
                                        >
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <template v-for="(field,index) in cadastreBuildingFields3">
                                                <div class="form-group" :key="field.code" v-if="isLeftField(field)">
                                                    <label>{{field.name}} <span class="red">*</span></label>
                                                    <template v-if="field.type === 'LISTBOX'">
                                                        <select class="form-control"
                                                                v-model="field.value3"
                                                                @change="onFieldValueChange(field)"
                                                                :class="{invalid : $v.cadastreBuildingFields3.$each[index].value3.$error}"
                                                        >
                                                            <option :value="option.id"
                                                                    v-for="option in cadastreBuildingFieldReferences[field.reference.code]"
                                                                    :key="option.id">{{option.name}}
                                                            </option>
                                                        </select>
                                                        <div class="red" v-if="$v.cadastreBuildingFields3.$each[index].value3.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                                    </template>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="col-md-6">
                                            <template v-for="(field) in cadastreBuildingFields3">
                                                <div class="form-group" :key="field.code" v-if="isRightField(field)">
                                                    <label>{{field.name}} <span class="red">*</span></label>
                                                    <template v-if="field.type === 'LISTBOX'">
                                                        <select class="form-control"
                                                                v-model="field.value3"
                                                                @change="onFieldValueChange(field)"
                                                        >
                                                            <option :value="option.id"
                                                                    v-for="option in cadastreBuildingFieldReferences[field.reference.code]"
                                                                    :key="option.id">{{option.name}}
                                                            </option>
                                                        </select>
                                                    </template>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_CAD_BUILDING_CONSTRUCTIVE_ADD')" @click="save" :disabled="processing">
                <i v-if="processing" class="fa fa-spinner fa-spin"></i>
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="show=!show">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import initFilterModel from '@/shared/filter';
    import {clone} from '@/shared/utils';
    import {required, requiredUnless} from 'vuelidate/lib/validators';
    import AdvancedFilter from '@/shared/filters/advancedFilter';

    export default {
        name: "CadastreBuildingConstructiveFieldEditModal",
        components: {
            'b-modal': bModal,
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                cadastreSectionFilter: initFilterModel(),
                cadastreBuildingFilter: initFilterModel(),
                filterBuildingType: new AdvancedFilter(),
                data: {
                    section: null,
                    cadastreBuilding: null,
                    earthquakePoint: null,
                    buildingType: null,
                    constructiveElements: {}
                },
                cadastreSections: [],
                cadastreBuildings: [],
                cadastreBuildingFields: [],
                cadastreBuildingFieldReferences: [],
                sectionFields: {
                    fields: ["foundation", "wall", "house_cover", "house_top", "floor_type", "window_and_doors"]
                },
                rightFields: {
                    fields: ["floor_type", "window_and_doors"]
                },
                leftFields: {
                    fields: ["foundation", "wall", "house_cover", "house_top"]
                },
                cadastreBuildingFields3: [],
                buildingTypes: []
            }
        },
        validations() {
            return {
                data: {
                    cadastreBuilding: {
                        required: required
                    },
                    buildingType: {
                        code: {
                            required: required
                        }
                    }
                },
                cadastreBuildingFields3: {
                    $each: {
                        value3: {
                            required: requiredUnless(vm => {
                                return !(this.hasSectionField(vm.code))
                            })
                        }
                    }
                }
            }
        },
        methods: {
            init(data) {
                const vm = this;
                this.$http.get('/cadastre/building/init')
                    .then(res => {
                        vm.cadastreBuildingFields = res.data.fields;
                        vm.cadastreBuildingFieldReferences = res.data.references;
                        vm.initData(data);
                    });
            },
            initData(data) {
                const vm = this;
                if (!data) {
                    data = {}
                } else {
                    data = clone(data);
                }

                if (!data.constructiveElements) {
                    data.constructiveElements = {}
                }

                vm.cadastreBuildingFields3 = [];
                if (data && data.cadastreBuilding && data.cadastreBuilding.id) {
                    vm.sectionFields.fields.forEach((field) => {
                        if (data.cadastreBuilding.data.fields.includes(field)) {
                            const buildingField = this.cadastreBuildingFields.filter((f) => f.code === field);
                            vm.cadastreBuildingFields3.push(buildingField[0]);
                        }
                    });

                    if (data.constructiveElements) {
                        this.cadastreBuildingFields3.forEach((field) => {
                            if (field.code && !field.system && data.constructiveElements.hasOwnProperty(field.code)) {
                                const fieldValue = data.constructiveElements[field.code];
                                if (fieldValue) {
                                    if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                                        if (fieldValue.id && fieldValue.id > 0) {
                                            field.value3 = fieldValue.id;
                                            field.selected3 = vm.getReferenceById(field.reference.code, fieldValue.id);
                                        }
                                    } else if (field.type === 'MULTISELECT') {
                                        if (fieldValue) {
                                            field.selected3 = [];
                                            if (fieldValue.length > 0) {
                                                fieldValue.forEach((ref) => {
                                                    field.selected3.push(ref.id);
                                                });
                                            } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                                                field.selected3.push(fieldValue.id);
                                            }
                                            field.value3 = field.selected3;
                                        }
                                    } else {
                                        field.value3 = fieldValue;
                                    }
                                }
                            }
                        })
                    }
                }
                this.data = data;
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                const vm = this;
                this.processing = true;

                this.$http.post('cadastre/building/constructive-field', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('cadastreBuildingConstructiveFieldChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            onCadastreSectionSearch(searchTxt, loading) {
                loading(true);
                this.cadastreSections = [];
                this.cadastreSectionFilter.search = searchTxt;
                this.$http.post('cadastre/section/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreSections = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCadastreSectionFocus() {
                this.cadastreSections = [];
                this.cadastreSectionFilter.search = '';
                this.$http.post('cadastre/section/search', this.cadastreSectionFilter)
                    .then(res => {
                        this.cadastreSections = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onCadastreBuildingSearch(searchTxt, loading) {
                loading(true);
                this.cadastreBuildings = [];
                this.cadastreBuildingFilter.page.size = 1000;
                this.cadastreBuildingFilter.search = searchTxt;

                this.$http.post('cadastre/building/search', this.cadastreBuildingFilter)
                    .then(res => {
                        this.cadastreBuildings = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCadastreBuildingFocus() {
                this.cadastreBuildings = [];
                this.cadastreBuildingFilter.page.size = 1000;
                this.$http.post('cadastre/building/search', this.cadastreBuildingFilter)
                    .then(res => {
                        this.cadastreBuildings = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onChangeCadastreSection() {
                let cadastreSections = [];

                this.initData(this.data);
                if (this.data.section) {
                    cadastreSections.push(this.data.section.id);
                    this.cadastreBuildingFilter.cadastreSections = cadastreSections
                }
            },
            onFieldValueChange(field) {
                if (!field.system) {
                    let fieldValue = {};
                    if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                        if (field.type === 'LISTBOX') {
                            field.selected3 = this.getReferenceById(field.reference.code, field.value3);
                        }
                        if (field.selected3) {
                            fieldValue = {
                                id: field.selected3.id,
                                code: field.selected3.code
                            }
                        }
                        if (field.type === 'COMBOBOX') {
                            field.value3 = fieldValue;
                        }
                    } else if (field.type === 'MULTISELECT') {
                        fieldValue = [];
                        if (field.selected3 && field.selected3.length > 0) {
                            field.selected3.forEach((ref_id) => {
                                const ref = this.getReferenceById(field.reference.code, ref_id);
                                if (ref) {
                                    fieldValue.push({
                                        id: ref.id,
                                        code: ref.code
                                    })
                                }
                            });
                        }
                        field.value3 = fieldValue;
                    } else {
                        fieldValue = field.value3;
                    }
                    this.data.constructiveElements[field.code] = fieldValue;
                }
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
            isRightField(field) {
               return this.rightFields.fields.includes(field.code)
            },
            isLeftField(field) {
               return this.leftFields.fields.includes(field.code)
            },
            onBuildingFocus() {
                this.buildingTypes = [];
                // this.filterBuildingType.cadastreType = this.realEstate.category
                this.filterBuildingType.onlyParentLookUp = true
                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        if (res.data !== "" && res.data.data.length > 0) {
                            this.buildingTypes = res.data.data;
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onChangeCadastreBuilding() {
                if (this.data.cadastreBuilding) {
                    this.initData(this.data)
                }
            },
            hasSectionField(code) {
                return this.leftFields.fields.includes(code);
            },
        },
        created() {
            this.$eventBus.$on('showConstructiveFieldEditModal', (data) => {
                this.init(data);
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>